import React from 'react';
import CRUDManager from '../../../shared/components/crud/CRUDManager';
import { parentRecordConfig } from '../config/patientRecordConfig';

export default function ParentRecordsPage() {
  return <CRUDManager config={parentRecordConfig} />;
}